export const UserNameContainerClasses = `
    flex
    items-center
    gap-2
    text-2xl
    text-primary
`
